"use strict";

export default class Localization {
  static Translate(message) {
    // localizationString is a global variable insert by Meta::JSLocalization
    if (!localizationString) {
      return message;
    }

    const localization = JSON.parse(Localization.decodeHtml(localizationString));

    return localization && localization[message] ? localization[message] : message;
  }

  static decodeHtml(html) {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;

    return txt.value;
  }
}